import React, { useState } from "react";
import Navbar from "./components/Navbar";
import CalibrationCalculator from "./components/CalibrationCalculator";
import IndicationError from "./components/IndicationError";
import ComparisonCalculator from "./components/ComparisonCalculator";
import HumidityConversion from "./components/HumidityConversion";
import ImageRecognition from "./components/ImageRecognition";
import AiInspection from "./components/AiInspection";
import "./App.css";

function App() {
  const [activeModule, setActiveModule] = useState("calibration");

  return (
    <div style={{ paddingTop: 72 }}>
      <Navbar activeModule={activeModule} setActiveModule={setActiveModule} />
      {activeModule === "calibration" && <CalibrationCalculator />}
      {activeModule === "indication" && <IndicationError />}
      {activeModule === "comparison" && <ComparisonCalculator />}
      {activeModule === "humidity-conversion" && <HumidityConversion />}
      {activeModule === "image-recognition" && <ImageRecognition />}
      {activeModule === "ai-inspection" && <AiInspection />}
    </div>
  );
}

export default App;
